export const environment = {
    production: true,
    apiUrl: 'https://caresupport.auctionventures.pl/api',
    apiKey: 'A6Ike8fNG9oiLSQyJxVQz94',
};
